import { queryOptions } from '@tanstack/react-query';

import { buildURL, post } from '@/shared/fetch';

import { QueryParams } from '../types';
import { getQueryFn } from '../utils';
import { Advertisement, GetAdvertisementsRequest } from './types';

export const getAdvertisementsQueryOptions = (params: GetAdvertisementsRequest | undefined) =>
  queryOptions({
    queryKey: ['advertisements', 'list', params],
    queryFn: getQueryFn<{ list: Advertisement[] }>('/advertisements', params as QueryParams),
    select: ({ list }) => list,
    enabled: !!params?.habitatId || !!params?.videoId,
    refetchOnWindowFocus: false,
  });

export const viewAdvertisementMutationFn = (advertisementId: string) =>
  post<void>(buildURL(`/advertisements/${advertisementId}/viewed`));
